// extracted by mini-css-extract-plugin
export default {"search-menu":"search-menu__dgpTr"};